import { logos, social } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .yolorekt_logo-stacked {
    background: url(${logos.yolorekt_logo_stacked_SOLID_FFFFFF}) center center / 240px no-repeat;
    width: 240px;
    height: 100%;
    display: flex;
    align-self: flex-end;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 0.75rem;
    padding: 30px 60px;
    margin: 30px 0 0 0;
    align-items: center;
    position: relative;
    bottom: 0;
    z-index: 11;
    width: 90%;
    flex-wrap: nowrap;
  }
  footer #landing-details {
    display: flex;
    flex-direction: row;
    min-width: auto;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  footer a {
    color: rgba(255, 255, 255, 1);
  }
  footer a:hover {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.2);
  }
  footer #copyright,
  footer #priv-terms {
    white-space: nowrap;
  }
  footer #copyright {
    padding: 5px 15px;
  }
  footer #landing-social {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 15px 0 0 0;
  }
  footer #landing-social a.icon {
    background-color: #fff;
    -webkit-mask-position: center center;
    mask-position: center center;
    color: rgba(255, 255, 255, 0.6);
    margin: 0 0 0 15px;
    display: block;
  }
  footer #landing-social a.twitter {
    -webkit-mask: url(${social.twitter_icon}) no-repeat;
    mask: url(${social.twitter_icon}) no-repeat;
    -webkit-mask-size: auto 20px;
    mask-size: auto 20px;
    width: 24px;
    height: 22px;
  }
  footer #landing-social a.tiktok {
    -webkit-mask: url(${social.tiktok_icon}) no-repeat;
    mask: url(${social.tiktok_icon}) no-repeat;
    -webkit-mask-size: auto 20px;
    mask-size: auto 20px;
    width: 24px;
    height: 22px;
  }
  footer #landing-social a.medium {
    -webkit-mask: url(${social.medium_icon}) no-repeat;
    mask: url(${social.medium_icon}) no-repeat;
    -webkit-mask-size: auto 18px;
    mask-size: auto 18px;
    width: 22px;
    height: 18px;
  }
  footer #landing-social a.telegram {
    -webkit-mask: url(${social.telegram_icon}) no-repeat;
    mask: url(${social.telegram_icon}) no-repeat;
    -webkit-mask-size: auto 20px;
    mask-size: auto 20px;
    width: 23px;
    height: 20px;
  }
  footer #landing-social a.discord {
    -webkit-mask: url(${social.discord_icon}) no-repeat;
    mask: url(${social.discord_icon}) no-repeat;
    -webkit-mask-size: auto 20px;
    mask-size: auto 20px;
    width: 26px;
    height: 20px;
  }
  footer #landing-social a.email {
    -webkit-mask: url(${social.email_icon}) no-repeat;
    mask: url(${social.email_icon}) no-repeat;
    -webkit-mask-size: auto 22px;
    mask-size: auto 22px;
    width: 32px;
    height: 22px;
  }
  footer #landing-social a.icon:hover {
    background-color: #2e68eb;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  #mobile_temp_page_wrapper {
    display: none;
  }
  @media (max-width: 600px) {
    #mobile_temp_page_wrapper {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 99;
      background: radial-gradient(
        circle at 50% 50%,
        hsla(210, 19%, 16%, 0.6),
        hsla(214, 19%, 15%, 0.6),
        hsla(210, 18%, 13%, 0.6),
        hsla(213, 19%, 12%, 0.6),
        hsla(216, 19%, 10%, 0.6),
        hsla(210, 18%, 9%, 0.7),
        hsla(214, 19%, 7%, 0.7),
        hsla(204, 17%, 6%, 0.8),
        hsla(210, 18%, 4%, 0.9),
        hsla(220, 20%, 3%, 1),
        hsla(180, 14%, 1%, 1),
        hsla(0, 0%, 0%, 1)
      );
      width: 100vw;
      height: 100%;
      -webkit-backdrop-filter: blur(25px);
      backdrop-filter: blur(25px);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 40px 0 0 0;
      flex-direction: column;
    }
    #mobile_temp_page_wrapper .yolorekt_logo-stacked {
      align-self: center;
      background-size: 120px auto;
      height: 62px;
      opacity: 0.5;
    }
    #mobile_temp_page_wrapper .pardon_our_dust {
      margin: 15px 0 0 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    #mobile_temp_page_wrapper .pardon_our_dust p {
      line-height: 140%;
      font-size: 0.85rem;
      font-weight: 200;
      text-align: center;
      padding: 10px 25px;
      border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    }
    #mobile_temp_page_wrapper .pardon_our_dust p.second {
      border-top: 0;
      font-size: 1rem;
      font-weight: 600;
      margin: 40px 0 0 0;
    }
    #mobile_temp_page_wrapper .yolobot_feature {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0 0 0;
    }
    #mobile_temp_page_wrapper .yolobot_feature .yolobot_logo {
      background: url('http://yolo.tino.me/app_v3/resources/images/yolobot/yolobot_logo_2.svg') center center / 320px
        auto no-repeat;
      width: 320px;
      height: 82px;
    }
    #mobile_temp_page_wrapper .yolobot_feature a#bot-button {
      background: hsla(0, 0%, 100%, 0.2);
      background: linear-gradient(
        180deg,
        hsla(0, 0%, 100%, 0.2),
        hsla(0, 0%, 96%, 0.2),
        hsla(0, 0%, 91%, 0.2),
        hsla(0, 0%, 87%, 0.2),
        hsla(0, 0%, 83%, 0.2),
        hsla(0, 0%, 79%, 0.2),
        hsla(0, 0%, 75%, 0.2),
        hsla(0, 0%, 71%, 0.2)
      );
      -webkit-backdrop-filter: blur(20px);
      backdrop-filter: blur(20px);
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 100%;
      border-radius: 20px;
      padding: 16px 30px 15px 30px;
      font-size: 1.2rem;
      color: #deff00;
      text-transform: uppercase;
      letter-spacing: -0.02em;
      margin: 20px 0 0 0;
    }
    #mobile_temp_page_wrapper .yolobot_feature a#bot-button strong {
      color: #deff00;
      font-weight: 700;
      padding: 0 0 0 30px;
      margin: 0 0 0 10px;
      background: url(http://yolo.tino.me/app_v3/resources/images/icons/telegram_logo.svg) left center / 22px auto
        no-repeat;
    }
    #mobile_temp_page_wrapper .yolobot_feature .view_docs {
      font-size: 0.9rem;
      margin: 25px 0 0 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    #mobile_temp_page_wrapper .yolobot_feature .view_docs a {
      border-bottom: 1px dotted hsla(0, 0%, 100%, 0.6);
    }
    #mobile_temp_page_wrapper footer {
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-size: 0.75rem;
      padding: 15px 0;
      margin: 0;
      align-items: center;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 11;
      width: 90%;
      flex-wrap: nowrap;
      color: #fff;
      opacity: 0.5;
    }
    #mobile_temp_page_wrapper footer:hover {
      opacity: 1;
    }
    #mobile_temp_page_wrapper footer #landing-details {
      display: flex;
      flex-direction: row;
      min-width: auto;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
    }
    #mobile_temp_page_wrapper footer a {
      color: #fff;
    }
    #mobile_temp_page_wrapper footer a:hover {
      border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
    }
    #mobile_temp_page_wrapper footer #copyright,
    #mobile_temp_page_wrapper footer #priv-terms {
      white-space: nowrap;
      font-size: 0.75rem;
      color: #fff;
      margin-bottom: 5px;
    }
    #mobile_temp_page_wrapper footer #priv-terms a {
      font-weight: 600;
      border-bottom: 1px dotted 0, 0%, 100%, 0.7;
    }
    #mobile_temp_page_wrapper footer #copyright {
      padding: 5px 15px;
    }
    #mobile_temp_page_wrapper footer #copyright strong {
      color: #fff;
    }
    #mobile_temp_page_wrapper footer #landing-social {
      display: flex;
      flex-direction: row;
      width: 100%;
      align-items: center;
      justify-content: center;
      padding: 5px 0 0 0;
    }
    #mobile_temp_page_wrapper footer #landing-social a.icon {
      background-color: #fff;
      -webkit-mask-position: center center;
      mask-position: center center;
      margin: 0 0 0 15px;
      display: block;
    }
    #mobile_temp_page_wrapper footer #landing-social a.twitter {
      -webkit-mask: url(${social.twitter_icon}) no-repeat;
      mask: url(${social.twitter_icon}) no-repeat;
      -webkit-mask-size: auto 20px;
      mask-size: auto 20px;
      width: 24px;
      height: 22px;
    }
    #mobile_temp_page_wrapper footer #landing-social a.tiktok {
      -webkit-mask: url(${social.tiktok_icon}) no-repeat;
      mask: url(${social.tiktok_icon}) no-repeat;
      -webkit-mask-size: auto 20px;
      mask-size: auto 20px;
      width: 24px;
      height: 22px;
    }
    #mobile_temp_page_wrapper footer #landing-social a.medium {
      -webkit-mask: url(${social.medium_icon}) no-repeat;
      mask: url(${social.medium_icon}) no-repeat;
      -webkit-mask-size: auto 18px;
      mask-size: auto 18px;
      width: 22px;
      height: 18px;
    }
    #mobile_temp_page_wrapper footer #landing-social a.telegram {
      -webkit-mask: url(${social.telegram_icon}) no-repeat;
      mask: url(${social.telegram_icon}) no-repeat;
      -webkit-mask-size: auto 20px;
      mask-size: auto 20px;
      width: 23px;
      height: 20px;
    }
    #mobile_temp_page_wrapper footer #landing-social a.discord {
      -webkit-mask: url(${social.discord_icon}) no-repeat;
      mask: url(${social.discord_icon}) no-repeat;
      -webkit-mask-size: auto 20px;
      mask-size: auto 20px;
      width: 26px;
      height: 20px;
    }
    #mobile_temp_page_wrapper footer #landing-social a.email {
      -webkit-mask: url(${social.email_icon}) no-repeat;
      mask: url(${social.email_icon}) no-repeat;
      -webkit-mask-size: auto 22px;
      mask-size: auto 22px;
      width: 32px;
      height: 22px;
    }
    #mobile_temp_page_wrapper footer #landing-social a.icon:hover {
      background-color: #2e68eb;
    }
  }
`

const developerCSS = css``

export const MobileWIPCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
